// Buscador propio (snippets/srj-buscador.liquid). La lupa del encabezado abre este panel en vez del modal de Dawn.
(function () {
  var raiz = document.querySelector('[data-srj-bus]');
  if (!raiz) return;
  var q = raiz.querySelector('[data-srj-bus-q]');
  var form = raiz.querySelector('[data-srj-bus-form]');
  var borrar = raiz.querySelector('[data-srj-bus-borrar]');
  var inicio = raiz.querySelector('[data-srj-bus-inicio]');
  var res = raiz.querySelector('[data-srj-bus-res]');
  var abierto = false, pedido = 0, espera = null, cache = {}, foco = null;

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var plata = function (p) { var n = parseFloat(p); return isNaN(n) ? '' : '$U' + Math.round(n).toLocaleString('es-UY'); };
  var conAncho = function (url, w) { if (!url) return ''; return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; };
  // marca en negrita las palabras buscadas dentro del título
  var resaltar = function (texto, termino) {
    var t = esc(texto);
    termino.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      var limpio = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      t = t.replace(new RegExp('(' + limpio + ')', 'ig'), '<mark>$1</mark>');
    });
    return t;
  };
  var familia = function (h) {
    if (/^piso-vinilico-spc/.test(h)) return 'Piso SPC';
    if (/^wpc-wall-panel-interior/.test(h)) return 'WPC interior';
    if (/^wpc-wall-panel-exterior/.test(h)) return 'WPC exterior';
    if (/^placa-pvc/.test(h)) return 'Placa símil mármol';
    if (/^viga/.test(h)) return 'Viga WPC';
    if (/^metal-siding/.test(h)) return 'Metal siding';
    if (/^perfil-wpc|^grapa/.test(h)) return 'Terminaciones WPC';
    if (/^(perfil-t|reductor|remate|zocalo)/.test(h)) return 'Terminaciones piso';
    return '';
  };

  var abrir = function () {
    if (abierto) return;
    abierto = true;
    foco = document.activeElement;
    raiz.hidden = false;
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () { raiz.classList.add('is-abierto'); });
    setTimeout(function () { q.focus(); q.select(); }, 30);
  };
  var cerrar = function () {
    if (!abierto) return;
    abierto = false;
    raiz.classList.remove('is-abierto');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { if (!abierto) raiz.hidden = true; }, 220);
    if (foco && foco.focus) { try { foco.focus({ preventScroll: true }); } catch (e) {} }
  };
  window.srjBuscador = { abrir: abrir, cerrar: cerrar };

  // la lupa del encabezado (summary del details-modal de Dawn): se intercepta antes que Dawn
  document.addEventListener('click', function (e) {
    var lupa = e.target.closest('.header__icon--search');
    if (!lupa) return;
    e.preventDefault();
    e.stopPropagation();
    var det = lupa.closest('details');
    if (det) det.removeAttribute('open');
    abrir();
  }, true);

  raiz.addEventListener('click', function (e) {
    if (e.target.closest('[data-srj-bus-cerrar]')) { cerrar(); return; }
    var chip = e.target.closest('[data-srj-bus-buscar]');
    if (chip) { q.value = chip.dataset.srjBusBuscar; cambio(true); q.focus(); }
  });
  borrar.addEventListener('click', function () { q.value = ''; cambio(true); q.focus(); });
  document.addEventListener('keydown', function (e) {
    if (!abierto) return;
    if (e.key === 'Escape') { e.preventDefault(); cerrar(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var links = [].slice.call(raiz.querySelectorAll((res.hidden ? '[data-srj-bus-inicio]' : '[data-srj-bus-res]') + ' a'));
      if (!links.length) return;
      e.preventDefault();
      var i = links.indexOf(document.activeElement);
      i = e.key === 'ArrowDown' ? (i < 0 ? 0 : Math.min(links.length - 1, i + 1)) : i - 1;
      if (i < 0) q.focus(); else links[i].focus();
    }
  });
  form.addEventListener('submit', function (e) { if (!q.value.trim()) e.preventDefault(); });

  var pintar = function (termino, r) {
    var prods = (r.products || []).slice(0, 6), cols = r.collections || [], arts = (r.articles || []).slice(0, 3);
    if (!prods.length && !cols.length && !arts.length) {
      res.innerHTML = '<div class="srj-bus__nada"><p><b>No encontramos “' + esc(termino) + '”.</b></p><p>Probá con otra palabra, como “WPC”, “piso” o “mármol”, o escribinos y te ayudamos.</p>' +
        '<a class="srj-bus__wa" href="https://wa.me/59892496741?text=' + encodeURIComponent('Hola, estoy buscando ' + termino) + '" target="_blank" rel="noopener">Consultar por WhatsApp</a></div>';
      return;
    }
    var h = '';
    if (prods.length) {
      h += '<p class="srj-bus__tit">Productos</p><div class="srj-bus__prods">' + prods.map(function (p) {
        var antes = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + plata(p.compare_at_price_max) + '</s>' : '';
        var piso = /^piso-vinilico-spc/.test(p.handle || '');
        var fam = familia(p.handle || '');
        return '<a class="srj-bus__prod" href="' + esc(p.url) + '">' +
          '<span class="srj-bus__prod-foto">' + (p.image ? '<img src="' + esc(conAncho(p.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '') + '</span>' +
          '<span class="srj-bus__prod-datos">' + (fam ? '<span class="srj-bus__prod-fam">' + fam + '</span>' : '') +
          '<span class="srj-bus__prod-nom">' + resaltar(p.title, termino) + '</span>' +
          '<span class="srj-bus__prod-precio">' + (p.available === false ? '<em>Sin stock</em>' : '<b>' + plata(p.price) + (piso ? ' el m²' : '') + '</b>' + antes) + '</span></span></a>';
      }).join('') + '</div>';
    }
    if (cols.length) {
      h += '<p class="srj-bus__tit">Categorías</p><div class="srj-bus__lista">' + cols.slice(0, 4).map(function (c) {
        return '<a class="srj-bus__fila" href="' + esc(c.url) + '"><span>' + resaltar(c.title, termino) + '</span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      }).join('') + '</div>';
    }
    if (arts.length) {
      h += '<p class="srj-bus__tit">Guías</p><div class="srj-bus__lista">' + arts.map(function (a) {
        return '<a class="srj-bus__fila" href="' + esc(a.url) + '"><span>' + resaltar(a.title, termino) + '</span><svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      }).join('') + '</div>';
    }
    h += '<a class="srj-bus__todos" href="' + esc(form.action) + '?q=' + encodeURIComponent(termino) + '&options%5Bprefix%5D=last">Ver todos los resultados de “' + esc(termino) + '”<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
    res.innerHTML = h;
  };

  // Sinónimos (Ronald, 21/10/2026): cómo lo dice la gente -> cómo se llama en la tienda. Se busca también el término de la tienda.
  var SINONIMOS = [
    [/wall ?panel|listones|listonado|ranurad|varillad|panel(es)? de madera/, 'wpc'],
    [/clips?\b|grapas?|ganchos?/, 'grapa'],
    [/pegamento|silicona|clavo liquido|pega\b|cola de contacto/, 'adhesivo'],
    [/flotante|vinilic|laminado|piso click/, 'piso spc'],
    [/marmol|marmolad/, 'marmol'],
    [/fachada|chapa simil madera/, 'metal siding'],
    [/vigas?|tirantes?/, 'viga'],
    [/terminacion|perfil|esquinero|angulo/, 'perfil']
  ];
  var norm = function (t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var extras = function (t) {
    var n = norm(t), out = [];
    SINONIMOS.forEach(function (s) { if (s[0].test(n) && n.indexOf(s[1]) === -1 && out.indexOf(s[1]) === -1) out.push(s[1]); });
    return out;
  };
  // el límite de Shopify (10) es para todo junto: productos por un lado y categorías y guías por otro
  var pedirSugerencias = function (t) {
    var base = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(t) +
      '&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,tag&resources[type]=';
    var uno = function (tipos) { return fetch(base + tipos, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) { return (d.resources && d.resources.results) || {}; }); };
    return Promise.all([uno('product'), uno('collection,article')]).then(function (rs) {
      return { products: rs[0].products || [], collections: rs[1].collections || [], articles: rs[1].articles || [] };
    });
  };
  // puntaje: cuántas palabras buscadas (o sus sinónimos) están en el nombre o la dirección del producto
  var palabrasOriginales = [];
  var ordenar = function (lista, palabras, clave) {
    var con = lista.map(function (x, i) {
      var donde = norm((x.title || '') + ' ' + String(x.handle || '').replace(/-/g, ' '));
      var p = palabras.reduce(function (s, w) { return s + (donde.indexOf(w) !== -1 ? 1 : 0); }, 0);
      return { x: x, p: p, i: i, ok: x.available !== false, d: donde };
    });
    // si hay coincidencias de verdad, se descarta lo que Shopify trajo solo por parecido
    if (con.some(function (c) { return c.p > 0; })) con = con.filter(function (c) { return c.p > 0; });
    // con 2 o más que tienen todas las palabras, se muestran solo esos ("perfil cedro" no trae perfiles de otro color)
    var todas = palabrasOriginales.length > 1 ? con.filter(function (c) { return palabrasOriginales.every(function (w) { return c.d.indexOf(w) !== -1; }); }) : [];
    if (todas.length >= 2) con = todas;
    con.sort(function (a, b) { return b.p - a.p || (clave ? (b.ok - a.ok) : 0) || a.i - b.i; });
    return con.map(function (c) { return c.x; });
  };
  var buscar = function (termino) {
    var n = ++pedido;
    if (cache[termino]) { pintar(termino, cache[termino]); return; }
    raiz.classList.add('is-cargando');
    var sin = extras(termino);
    var palabras = norm(termino).split(/\s+/).filter(function (w) { return w.length > 1; });
    palabrasOriginales = palabras.slice();
    sin.forEach(function (x) { x.split(' ').forEach(function (w) { if (palabras.indexOf(w) === -1) palabras.push(w); }); });
    Promise.all([termino].concat(sin).map(pedirSugerencias))
      .then(function (rs) {
        var junta = { products: [], collections: [], articles: [] }, visto = {};
        rs.forEach(function (r) {
          ['products', 'collections', 'articles'].forEach(function (k) {
            (r[k] || []).forEach(function (x) { var id = k + (x.handle || x.url); if (!visto[id]) { visto[id] = 1; junta[k].push(x); } });
          });
        });
        var r = { products: ordenar(junta.products, palabras, true), collections: ordenar(junta.collections, palabras), articles: ordenar(junta.articles, palabras) };
        cache[termino] = r;
        if (n === pedido) pintar(termino, r);
      })
      .catch(function () { if (n === pedido) res.innerHTML = '<div class="srj-bus__nada"><p>No pudimos buscar ahora. Probá de nuevo en un momento.</p></div>'; })
      .finally(function () { if (n === pedido) raiz.classList.remove('is-cargando'); });
  };

  var cambio = function (ya) {
    var t = q.value.trim();
    borrar.hidden = !q.value;
    clearTimeout(espera);
    if (!t) { res.hidden = true; inicio.hidden = false; res.innerHTML = ''; pedido++; raiz.classList.remove('is-cargando'); return; }
    inicio.hidden = true; res.hidden = false;
    espera = setTimeout(function () { buscar(t); }, ya ? 0 : 180);
  };
  q.addEventListener('input', function () { cambio(false); });
})();
